
import generateReport from "../../services/AxiosReportService";
import api from "../../services/AxiosService";

export const getLoanStatistic = (branchId) => {
    return api("post", "api/loans/index", branchId, null);
};

export const generateLoanTypeReport = () => {
    return generateReport("post", "api/loan/loan-type/generate", "", null);
};

export const generateLoanSummaryReports = (data) => {
    return generateReport("post", "api/loan/branch/generate", "", data);
};

export const getDistrictBranches = () => {
    return api("get", "api/district-branch/list", "", null);
};

export const getDivAreaBranches = () => {
    return api("get", "api/div-branch/list", null);
}

export const generateBranchLoanReport = (data) => {
    return generateReport("post", "api/loan/branch-wise/generate", "", data);
};

export const generateDistrictReport = (data) => {
    return generateReport("post", "api/loan/district/generate", "", data);
};

export const generateDistrictLoanProductReport = (data) => {
    return generateReport("post", "api/loan/district/product/generate", "", data);
};

export const generateLoanReportForDay = (data) => {
    return api("post", "api/loan/loan-disbursement-outstanding", "", data);
};

export const generateDistrictLoanReport = (data) => {
    return api("post", "api/loan/district-wise/generate", "", data)
};

export const generateLoanSummaryReportforDistrict = (data) => {
    return generateReport("post", "api/loan/loan-type-district/generate", "", data)
};

export const generateActiveAndDormantWasamWise = (data) => {
    return generateReport("post", "api/loan/loan-trail-balance", "", data);
};
//loan pending installment
export const generateLoanPendingInstallment = (data) => {
    return api("post", "api/loan/loan-pending_installment", "", data);
};

//loan certificate
export const generateLoanCertificate = (data) => {
    return generateReport("post", "api/loan/loan-certificate", "", data);
};



// chenuka
export const generateTrailBalanceByDate = (data) => {
    return generateReport("post", "api/loan/loan-trail-balance-by-date-range", "", data);
};

// 

export const getAllLoans = () => {
    return api("get", "api/products/loans", "", null);
};

export const generateLoanDisposeSummaryReport = (data) => {
    return api("post", "api/loan/dispose-summary-wise/generate", "", data);
};

export const generateAllDisposeSummaryReport = (data) => {
    return api("post", "api/loan/dispose-summary/generate", "", data);
};

export const generateDisbursementAmountReportB = (data) => {
    return generateReport("post", "api/loan/dispose", "", data);
};

export const generateLoanDisbursementSummaryReport = (data) => {
    return api("post", "api/loan/loan-disbursement-summary", "", data);
};

export const getLoanSummary = (data) => {
    return api("post", "api/loan-summary/excel", "", data);
};

export const getLoanPaymentHistory = (data) => {
    return api("post", "api/loan/loan-inquiry-summary", "", data);
};

export const getCustomerLoanDetails = (data) => {
    return api("post", "api/loan/customer-loan-details", "", data);
};

export const getWasamaCustomerLoanDetails = (data) => {
    return api("post", "api/loan/customer-loan-details-wasama-wise", "", data);
};

export const getLoanApplicationsProgressReport = (data) => {
    return api("post", "api/loan/loan-applications-progress", "", data);
};

export const getLoanProgressReport = (data) => {
    return api("post", "api/loan/loan-progress", "", data);
};